var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSettingsIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0.5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.525,27h-4.05V23.415A9.891,9.891,0,0,1,7.92,21.945L5.385,24.48,2.52,21.615,5.055,19.08A10.187,10.187,0,0,1,3.57,15.525H0v-4.05H3.57A9.889,9.889,0,0,1,5.04,7.92L2.52,5.4,5.385,2.535,7.9,5.055a10.171,10.171,0,0,1,3.57-1.485V0h4.05V3.57A10.187,10.187,0,0,1,19.08,5.055l2.52-2.52L24.465,5.4l-2.52,2.52a9.891,9.891,0,0,1,1.471,3.555H27v4.05H23.415A10.2,10.2,0,0,1,21.93,19.08l2.534,2.535L21.6,24.48l-2.535-2.535a9.856,9.856,0,0,1-3.54,1.471V27ZM13.5,7.425A6.075,6.075,0,1,0,19.575,13.5,6.082,6.082,0,0,0,13.5,7.425Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSettingsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/settings-icon.9ab874d0.svg";
export { ForwardRef as ReactComponent };